module.exports = __webpack_public_path__ + "static/media/stable-token.28d63f65.svg";